(function(){
  var bar = document.getElementById('krea-cta');
  var ctaBtn = document.getElementById('krea-cta-btn');
  if (!bar || !ctaBtn) return;
  if (window.innerWidth >= 750) { bar.style.display = 'none'; return; }

  // Clic en barra → activa botón nativo
  ctaBtn.addEventListener('click', function(){
    var nb = document.querySelector('[data-krea-atc]');
    if (nb && !nb.disabled) {
      nb.click();
      var orig = ctaBtn.textContent.trim();
      ctaBtn.textContent = '\u2713';
      setTimeout(function(){ ctaBtn.textContent = orig; }, 1500);
    }
  });

  // Actualizar precio al cambiar variante
  document.addEventListener('variant:change', function(e){
    if (!e.detail || !e.detail.variant) return;
    var v = e.detail.variant;
    var priceEl = document.getElementById('krea-cta-price');
    if (priceEl && v.price) {
      priceEl.textContent = (v.price/100).toLocaleString('es-ES',{style:'currency',currency:'EUR'});
    }
    ctaBtn.disabled = !v.available;
  });

  // Lógica de visibilidad basada en scroll
  function getNativeBtn() {
    return document.querySelector('[data-krea-atc]');
  }

  function updateBarVisibility() {
    var nb = getNativeBtn();
    if (!nb) { bar.style.display = 'flex'; return; }
    var rect = nb.getBoundingClientRect();
    // El botón nativo es visible si alguna parte está en el viewport
    var inView = rect.bottom > 0 && rect.top < window.innerHeight;
    bar.style.display = inView ? 'none' : 'flex';
  }

  // Escuchar scroll con throttle ligero
  var ticking = false;
  window.addEventListener('scroll', function(){
    if (!ticking) {
      window.requestAnimationFrame(function(){
        updateBarVisibility();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Check inicial tras carga completa
  if (document.readyState === 'complete') {
    updateBarVisibility();
  } else {
    window.addEventListener('load', updateBarVisibility);
  }
  setTimeout(updateBarVisibility, 800);
  setTimeout(updateBarVisibility, 1500);

})();
